import axios from "../config/axios";

/**
 * Consultar por los cuestionarios/formularios existentes para un paciente.
 *
 * @param {Number} documento  Número de documento del paciente
 * @return {status: Number, data: [{nombre: String, tipo_esquema: String, esquema: String}], message: String}
 */
export async function consultarFormulariosExistentes(documento) {
  return await axios.post(
    "/formularios_cuestionarios/gestion/api/v2/autogestion",
    { documento }
  );
}

/**
 *
 * @param {Sgtring} docId Id del formulario/cuestionario
 * @param {String} key nombre del formulario
 * @param {[{nombre: String, valor: Object},...]} variables un arreglo de objetos {nombre, valor}
 * @param {String} esquema Tipo formulario/cuestionario
 */
export async function actualizarFormulario(docId, key, variables, coleccion) {
  return await axios.put(
    `/formularios_cuestionarios/${coleccion}/api/v3/actualizar`,
    {
      creado_por: "paciente@neumomed.com",
      docId,
      key,
      variables
    }
  );
}

/**
 *
 * @param {Sgtring} docId Id del formulario/cuestionario
 */
export async function eliminarFormulariosExistentes(docId) {
  /** FALTA MODIFICAR (V3) */
  return await axios
    .delete(`/formularios_cuestionarios/formularios/api/v2/eliminar`, {
      data: { docId }
    })
    .then(result => {
      if (result && result.response && result.response.status === 400) {
        return result.response;
      }
      return result;
    })
    .catch(err => err.response);
}

/**
 *
 * @param {String} docId Id del formulario/cuestionario
 * @param {*} esquema
 */
export async function consultarEstructuraFormularioPorId(docId, formulario) {
  return await axios.get(
    `/formularios_cuestionarios/${formulario.coleccion}/api/v3/leer`,
    {
      params: {
        docId,
        tipo_esquema: formulario.tipo_esquema
      }
    }
  );
}

/**
 *
 * @param {{nombre: String, tipo_esquema: String, esquema: String}} formulario Objeto que almacena la información de un formulario/cuestionario
 * @param {String} documento Documento del paciente asociado con el formulario
 */
export async function consultarFormulario(formulario, documento) {
  return await axios.post(
    `formularios_cuestionarios/${formulario.coleccion}/api/v3/crear`,
    {
      tipo_esquema: formulario.tipo_esquema,
      documento: documento,
      creado_por: "paciente@neumomed.com",
      id: null,
      origen: null,
      momento: null
    }
  );
}
